module.exports = __webpack_public_path__ + "img/logo-white.39e77893.svg";